import styled from "@emotion/styled";
import { CheckboxFormControl } from "@kaltura/ds-react-components";
import { formControlLabelClasses } from "@mui/material";
import { KmsTypeFilterItemCheckbox } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { ChangeEvent } from "react";
import { FilterItemAdditionalProps } from "./FilterItemAdditionalProps";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { SpanSrOnly } from "@kaltura/mediaspace-shared-ui";

export type CheckboxFilterItemProps = KmsTypeFilterItemCheckbox & FilterItemAdditionalProps;

const StyledCheckboxFilterItem = styled("div")(({ theme }) => ({
    marginTop: 0,
    marginBottom: theme.spacing(2),
    [`& .${formControlLabelClasses.label} p`]: { fontSize: 14 },
}));

/**
 * checkbox filter item - a single (controlled)checkbox in a filter
 */
export function CheckboxFilterItem(props: CheckboxFilterItemProps) {
    const sendButtonAnalytics = useButtonAnalytics();
    const {
        label,
        param,
        value,
        checked = false,
        equalsAll = false,
        onChange,
        disabled = false,
        isDefaultValue = false,
    } = props;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (equalsAll && !event.target.checked) {
            // equalsAll cant be unchecked manually
            return;
        }
        const eventName = `Filters - ${param} - ${value} - ${event.target.checked ? "Checked" : "Unchecked"} `;
        sendButtonAnalytics(eventName, ButtonClickAnalyticsType.FILTER);
        onChange(param, value, event.target.checked, equalsAll);
    };

    // For default values, enhance the label with screen-reader-only text
    const enhancedLabel = isDefaultValue ? (
        <>
            {label}
            <SpanSrOnly> {translate("default filter value")}</SpanSrOnly>
        </>
    ) : (
        label
    );

    return (
        <StyledCheckboxFilterItem className="kms-ds-checkbox-filter-item">
            <CheckboxFormControl
                label={enhancedLabel}
                value={value}
                disabled={disabled}
                checked={checked}
                onChange={handleChange}
            />
        </StyledCheckboxFilterItem>
    );
}

export default CheckboxFilterItem;
